import {FC, createContext, useState, useEffect, useMemo, ReactNode} from 'react';
import {buildUrlParams, getFiltersFromParams} from "./filtersHandler.ts";
import buildSolrParams from "./buildSolrParam.ts";
import {useOriginalDatas} from "../Hooks/useOriginalDatas.ts";

interface FiltersContextUpdateType {
  handleFilters: (filterIndex: any, filterValue: any) => void;
  handleReset: () => void;
}

interface FiltersProviderProps {
  children: ReactNode; // This type is from React and allows any valid React child
}

interface FiltersContextType{
  filterParams: Param[];
  filters: Filter[];
}
export const FiltersContext = createContext<FiltersContextType>({
  filterParams: [],
  filters: []
});
export const FiltersContextUpdate = createContext<FiltersContextUpdateType>({
  handleFilters: () => {},
  handleReset: () => {}
})
export const FiltersProvider: FC<FiltersProviderProps> =  ({ children }) => {

  // const [filterParams, setFilterParams] = useState<Param[]>([])
  const [filters, setFilters] = useState<Filter[]>(getFiltersFromParams());
  const { originalDatas} = useOriginalDatas();

  const handleFilters = (filterIndex: any, filterValue: any) => {

    setFilters(prevFilters => {
      // Check if the filterValue is empty (you can adjust the condition as needed)
      const isEmptyValue = !filterValue || (Array.isArray(filterValue) && filterValue.length === 0);

      // Find the index of the object with the same id
      const existingIndex = prevFilters.findIndex(filter => filter.id === filterIndex);

      // Create a copy of the filters array
      let updatedFilters = [...prevFilters];

      // If the filterValue is empty, remove the filter
      if (isEmptyValue) {
        if (existingIndex !== -1) {
          // Remove the filter at the existingIndex
          updatedFilters.splice(existingIndex, 1);
        }
        // Nothing to do if the filter doesn't exist already
      } else {
        // If the object with the same id is found and value is not empty, replace the old values
        if (existingIndex !== -1) {
          updatedFilters[existingIndex] = {id: filterIndex, values: filterValue};
        } else {
          // If not found, push the new object with the id and values
          updatedFilters.push({id: filterIndex, values: filterValue});
        }
      }

      // Return the updated filters array
      return updatedFilters;
    });
  };

  const handleReset = () => {
    setFilters([])
  }

  const filterParams = useMemo(() => {
    // This will only recompute if filters or originalDatas change
    return buildSolrParams(filters, originalDatas);
  }, [filters, originalDatas]);


  useEffect(() => {
    buildUrlParams(filters);
  }, [filters, originalDatas]);

  return(
    <FiltersContext.Provider value={{filterParams, filters}}>
      <FiltersContextUpdate.Provider value={{handleFilters, handleReset}}>
        {children}
      </FiltersContextUpdate.Provider>
    </FiltersContext.Provider>
  )
};
